import React from 'react';
import './styles.css';

const DestructiveButton = ({
                               disabled,
                               loading = false,
                               children,
                               onClick,
                               width = '100%',
                               height = null,
                               size = null,
                               iconOnly = false,
                               type = 'submit',
                               variant = 'default',
                               styles = {},
                           }) => {
    let classes = 'ds-button destructive-button';

    if (size) classes += ` ds-button--${size}`;
    if (iconOnly) classes += ' ds-button--icon';
    if (variant === 'outline') classes += ' destructive-button--outline';

    return (
        <button
            disabled={disabled || loading}
            type={type}
            className={classes}
            style={{
                width,
                height: height || (size ? undefined : '50px'),
                ...styles,
            }}
            onClick={onClick}
        >
            {loading && <span className="ds-button__spinner"/>}
            {children}
        </button>
    );
};

export default DestructiveButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/DestructiveButton/index.jsx